<div class="mars-nca-details-section">
  <div class="mars-nca-header-block">
    <p class="eclipse-main-tab-header">Initiation - MARS NCA</p>
    <div class="buttons-flex-sub-container padding-right-xs">
      <dds-button id="initiation-mars-nca-initiate-button"
                  [theme]="initiateButtonOptions.theme ?? ''"
                  [kind]="initiateButtonOptions.kind ?? ''"
                  [size]="initiateButtonOptions.size ?? ''"
                  [width]="initiateButtonOptions.width ?? ''"
                  [ariaLabel]="initiateButtonOptions.ariaLabel ?? ''"
                  [disabled]="!this.isValid() || this.isActiveMarsFormExists"
                  (clicked)="initiateMars()">Initiate</dds-button>
      <dds-button id="initiation-mars-nca-cancel-button"
                  [theme]="cancelButtonOptions.theme ?? ''"
                  [kind]="cancelButtonOptions.kind ?? ''"
                  [size]="cancelButtonOptions.size ?? ''"
                  [width]="cancelButtonOptions.width ?? ''"
                  [ariaLabel]="cancelButtonOptions.ariaLabel ?? ''"
                  (clicked)="cancelPage()">Cancel</dds-button>
    </div>
  </div>
  <p class="eclipse-content-grey">Provide all required information and select "Initiate" to create a new MARS NCA request</p>

  <div id="mars-nca-initiate-questionaire">
    <div>
      <div class="margin-top-s">
        <span [hidden]="isClientNotListed ? otherClientName : model.clientName" class="icon-required-yellow"></span>
        <span class="text-label">Client name:</span>
      </div>
      <div class="mars-nca-flex-box margin-top-xs">

        <div *ngIf="!isClientNotListed; else ClientNotListedElseBlock" class="col-4">
          <div ngbDropdown #clientdropdown="ngbDropdown" class="client-picker mars-nca-flex-sub-container">
            <div class="search-container" ngbDropdownAnchor>
              <dds-search [formControl]="clientSearchFormCtrl"
                          [size]="searchOptions.size ?? ''"
                          [icon]="!clientSelectedItem ? (searchOptions.icon || 'dds-icon_search') : ''"
                          (valueChanged)="clientSearch()"
                          (fieldCleared)="clearClientSearch()">
                <input ddsSearch
                       [placeholder]="clientSelectedItem ? '' : searchOptions.placeholder ?? ''"
                       [(ngModel)]="clientSearchKey"
                       (input)="clientSearch()"
                       (click)="clientInputClick()"
                       [ngClass]="{'hidden': clientSelectedItem}" />
              </dds-search>
              <div *ngIf="clientSelectedItem" class="selected-item-display">
                <span class="client-number padding-right-xxs">{{ clientSelectedItem.clientName }}</span>
                <span class="sap-id padding-right-xxs">(ID: {{ clientSelectedItem.clientNumber }})</span>
                <span class="dds-icon dds-icon_close" (click)="clearClientSearch()"></span>
              </div>
            </div>
            <div #menu ngbDropdownMenu role="menu" aria-labelledby="single-button" class="items-dropdown">
              <div class="search-list-label padding-bottom-none" [hidden]="!isLoading">Searching...</div>
              <div [hidden]="isLoading">
                <div class="no-matches" [hidden]="clientFilteredItems.length != 0">No matches found</div>
              </div>
              <button *ngFor="let item of clientFilteredItems" ngbDropdownItem (click)="selectItem(item)">
                <div class="dropdown-item-content">
                  <span class="client-number padding-right-xxs">{{ item.clientName }}</span>
                  <span class="sap-id padding-right-xxs">(ID: {{ item.clientNumber }})</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <ng-template #ClientNotListedElseBlock>
          <div class="col-4">
            <dds-input class="mars-nca-flex-sub-container"
                       [placeholder]="inputOptions.placeholder ?? ''"
                       [size]="inputOptions.size ?? ''"
                       [maxLength]="inputOptions.maxLength ?? 0"
                       [maxLengthPosition]="inputOptions.maxLengthPosition ?? ''"
                       [(ngModel)]="otherClientName"
                       (ngModelChange)="changeClientName()"
                       [disabled]="isCheckingNameInProcess"></dds-input>
          </div>
        </ng-template>


        <dds-checkbox class="mars-nca-flex-sub-container padding-xs"
                      [ngClass]="{'client-not-listed-margin': isClientNotListed}"
                      [formControl]="checkboxFormCtrl"
                      [label]="options.label ?? ''"
                      [theme]="options.theme ?? ''"
                      (stateChanged)="stateChanged()">
        </dds-checkbox>
        <span class="mars-nca-flex-sub-container padding-right-xs margin-top-xs icon-info"
              [ngClass]="{'client-not-listed-margin': isClientNotListed}"
              [ddsTooltip]="'enter full legal entity name'"
              [tooltipInvokeType]="clientTooltipOptions.tooltipInvokeType ?? ''"
              [tooltipType]="clientTooltipOptions.tooltipType ?? ''"
              [tooltipSize]="clientTooltipOptions.tooltipSize  ?? ''"
              [tooltipPosition]="clientTooltipOptions.tooltipPosition ?? ''"
              [tooltipIndent]="clientTooltipOptions.tooltipIndent ?? 0"
              [tooltipHasBeak]="clientTooltipOptions.tooltipHasBeak ?? false"
              [tooltipTheme]="clientTooltipOptions.tooltipTheme ?? ''" ddsFocus
              [tooltipMaxWidth]="clientTooltipOptions.tooltipMaxWidth ?? 0"></span>
      </div>

      <div class="margin-top-xs" *ngIf="isClientNotListed ? (isClientNameExists && !isCheckingNameInProcess) : isActiveMarsFormExists">
        <span class="text-red">
          MARS NCA request is already in progress for this client
        </span>
      </div>
    </div>
    <!-- <div >
      <span>
        <p>My Name is khan</p>
      </span>
    </div> -->

    <div class="row">
      <div class="col-11">
        <div class="container margin-top-s margin-bottom-s" *ngIf="isClientNotListed">
          
          <div class="top-header">
            <div class="icon-alert-logo-container">
              <div class="icon-alert-logo"></div>
            </div>
            <div class="text-container">
              
              <div>
                <p [innerHTML] = "appconfigurationsNcaCc['GUIDE_MARS_NOCLIENT']"></p>
                <br>
                <p>
                  If no entry is found for the entity, please create a Jupiter Account for the client. 
                  For any assistance with SWIFT / Jupiter related matters, please contact 
                  <a href="mailto:usmercuryadvisorysupport@deloitte.com" class="text-green">US Advisory Jupiter Support</a>.
                </p>
              </div>
              <div class="vertical-line" *ngIf="isClientNotListed"></div>
              <!-- <dds-button *ngIf="!isshowmorevisible" [theme]="options.theme ?? ''"
                          [kind]="options.kind ?? ''"
                          [size]="options.size ?? ''"
                          [width]="options.width ?? ''"
                          [icon]="options.icon ??''"
                          [isIconLeft]="options.isIconLeft ?? false"
                          [role]="options.role ?? ''"
                          [ariaLabel]="options.ariaLabel ?? ''"
                          [customClass]="options.customClass ?? ''"
                          (clicked)="clickshowmore($event)">Show More</dds-button> -->
            </div>
          </div>

        </div>
      </div>
    </div>

    <div>
      <div class="margin-top-m">
        <span [hidden]="model.marsClientTypeID" class="icon-required-yellow"></span>
        <span class="text-label">Client type:</span>
      </div>
      <div class="col-4 margin-top-xs">
        <dds-select [list]="optionsMARSClientType" [placeholder]="selectOptionsMARSClientType.placeholder ?? ''"
                    [size]="selectOptionsMARSClientType.size ?? ''"
                    [(ngModel)]="model.marsClientTypeID">
        </dds-select>
      </div>
    </div>
    <div>
      <div class="margin-top-m">
        <span [hidden]="model.recommendingPpmd" class="icon-required-yellow"></span>
        <span class="text-label">Recommending PPMD:</span>
      </div>
      <div class="mars-nca-flex-box margin-top-xs">
        <div ngbDropdown #ppmddropdown="ngbDropdown" class="client-picker col-4 mars-nca-flex-sub-container">
          <div class="search-container" ngbDropdownAnchor>
            <dds-search [formControl]="ppmdSearchFormCtrl"
                        [size]="searchOptions.size ?? ''"
                        [icon]="!ppmdSelectedItem ? (searchOptions.icon || 'dds-icon_search') : ''"
                        (valueChanged)="PPMDSearch()"
                        (fieldCleared)="clearPPMDSearch()">
              <input ddsSearch
                     [placeholder]="ppmdSelectedItem ? '' : searchOptions.placeholder ?? ''"
                     [(ngModel)]="ppmdSearchKey"
                     (input)="PPMDSearch()"
                     (click)="PPMDInputClick()"
                     [ngClass]="{'hidden': ppmdSelectedItem}" />
            </dds-search>
            <div *ngIf="ppmdSelectedItem" class="selected-item-display">
              <span class="client-number padding-right-xxs">{{ ppmdSelectedItem.outlookDisplayName }}</span>
              <span class="dds-icon dds-icon_close" (click)="clearPPMDSearch()"></span>
            </div>
          </div>
          <div #menu ngbDropdownMenu role="menu" aria-labelledby="single-button" class="items-dropdown">
            <div class="search-list-label padding-bottom-none" [hidden]="!isLoading">Searching...</div>
            <div [hidden]="isLoading">
              <div class="no-matches" [hidden]="ppmdFilteredItems.length != 0">No matches found</div>
            </div>
            <button *ngFor="let item of ppmdFilteredItems" ngbDropdownItem (click)="selectItemPPMD(item)">
              <div class="dropdown-item-content">
                <span class="client-number padding-right-xxs">{{ item.outlookDisplayName }}</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="margin-top-m">
        <span [hidden]="model.isHedgeFund" class="icon-required-yellow"></span>
        <span class="text-label">Is the prospective client a hedge fund, underwriter, lender,
          <a class="hover-text"
             [ddsTooltip]="appconfigurationsNcaCc['MARS_Q_prospective_client_Tooltip']"
             [tooltipInvokeType]="clientTooltipOptions.tooltipInvokeType ?? ''"
             [tooltipType]="clientTooltipOptions.tooltipType ?? ''"
             [tooltipSize]="clientTooltipOptions.tooltipSize  ?? ''"
             [tooltipPosition]="clientTooltipOptions.tooltipPosition ?? ''"
             [tooltipIndent]="clientTooltipOptions.tooltipIndent ?? 0"
             [tooltipHasBeak]="clientTooltipOptions.tooltipHasBeak ?? false"
             [tooltipTheme]="clientTooltipOptions.tooltipTheme ?? ''" ddsFocus
             [tooltipMaxWidth]="clientTooltipOptions.tooltipMaxWidth ?? 0">business development company</a>, special <br />purpose acquisition company (SPAC), development stage entity, sovereign wealth fund or other state-<br />owned or controlled enterprise, or high net worth individual?
        </span>
      </div>
      <div class="col-3 margin-top-xs">
        <dds-radio-group name="isHedgeFundOptions" [(ngModel)]="model.isHedgeFund">

          <ng-container *ngFor="let radio of radioBtns">
            <dds-radio class="radio-btn"
                       [value]="radio.value !== undefined ? radio.value : ''"
                       [label]="radio.options.label ?? ''"
                       [theme]="radio.options.theme ?? ''"></dds-radio>
            <br />
          </ng-container>
        </dds-radio-group>
      </div>
      <div class="margin-top-s margin-bottom-s" *ngIf="model.isHedgeFund === 'true'">
        <div class="disclaimer-message-container">
          <span class="dds-icon dds-icon_pin pin-style"></span>
          <div class="eclipse-content-grey pin-margin">
            <span class="margin-top-xxs" [innerHTML]="appconfigurationsNcaCc['GUIDE_MARS_QAR_REF']"></span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="margin-top-m">
        <span [hidden]="model.isConsultedWithQrm" class="icon-required-yellow"></span>
        <span class="text-label">Have you consulted with MARS QRM?
        </span>
      </div>
      <div class="col-3 margin-top-xs">
        <dds-radio-group name="isConsultedWithQrmOptions"
                         [(ngModel)]="model.isConsultedWithQrm"
                         (ngModelChange)="changeIsConsultedWithQrm()"
                         [disabled]="isMarsConsultationWithMarsQrmSummaryDisabledBySecurity">

          <ng-container *ngFor="let radio of radioBtns">
            <dds-radio class="radio-btn"
                       [value]="radio.value !== undefined ? radio.value : ''"
                       [label]="radio.options.label ?? ''"
                       [theme]="radio.options.theme ?? ''"
                       [disabled]="isMarsConsultationWithMarsQrmSummaryDisabledBySecurity"></dds-radio>
            <br />
          </ng-container>
        </dds-radio-group>
      </div>
      <div class="margin-top-s margin-bottom-s" *ngIf="model.isConsultedWithQrm === 'true'">
        <div class="margin-top-m">
          <span [hidden]="model.applicableMarsQrm" class="icon-required-yellow"></span>
          <span class="text-label">Applicable MARS QRM:</span>
        </div>
        <div class="col-4 margin-top-xs">
          <dds-select [formControl]="selectFormCtrl"
                      [list]="filteredMarsQrmList"
                      [placeholder]="selectOptionsMarsQrm.placeholder ?? ''"
                      [size]="selectOptionsMarsQrm.size ?? ''"
                      [optionsTemplate]="optionsTemplate"
                      (valueChanged)="selectMarsQrm()"
                      (click)="resetMarsQrmList()"
                      >
          </dds-select>
          <ng-template #optionsTemplate let-ctx="ctx">
            <dds-context-menu [size]="ctx.size" [label]="ctx.label" [maxHeight]="ctx.stickerMaxHeight"
              [isResponsive]="ctx.isResponsive" [ariaLabel]="ctx.popupAriaLabel" [activeItemId]="ctx.activeItemId"
              [isRequired]="ctx.isRequired" [isInverse]="ctx.isInverse" [isLoading]="ctx.isLoading"
              [isLoadingWithCounter]="ctx.isLoadingWithCounter" [loadingTemplate]="ctx.loadingTemplate" [id]="ctx.id"
              class="dds-select__list" (keyPressed)="ctx.handleKeydownMenu($event)" (onInit)="ctx.contextMenuInit($event)"
              (closed)="ctx.close()">
              <dds-search [size]="searchOptions.size ?? ''" [customClass]="searchOptions.customClass ?? ''"
                [icon]="searchOptions.icon || 'dds-icon_search'" (click)="onMarsQrmSearch($event)"
                (fieldCleared)="resetMarsQrmList()" class="dds-search">
                <input ddsSearch [placeholder]="marsQrmSearchOptions.placeholder ?? ''" (input)="onMarsQrmSearch($event)">
              </dds-search>
              <div class="no-matches" [hidden]="ctx.list.length != 0">No matches found</div>
              <dds-context-menu-item *ngFor="let item of ctx.list" [disabled]="item.disabled" [customClass]="item.customClass"
                (selectedItem)="ctx.changeItem(item)">
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <span>{{item.heading}}</span>
                </div>
              </dds-context-menu-item>
            </dds-context-menu>
          </ng-template>
        </div>

        <div class="margin-top-m">
          <span [hidden]="model.consultationSummary" class="icon-required-yellow"></span>
          <span class="text-label padding-right-xs">Consultation summary with MARS QRM:</span>
          <span class="icon-required-yellow margin-top-xs icon-info"
                [ddsTooltip]="consultationSummaryHoverText"
                [tooltipInvokeType]="clientTooltipOptions.tooltipInvokeType ?? ''"
                [tooltipType]="clientTooltipOptions.tooltipType ?? ''"
                [tooltipSize]="clientTooltipOptions.tooltipSize  ?? ''"
                [tooltipPosition]="clientTooltipOptions.tooltipPosition ?? ''"
                [tooltipIndent]="clientTooltipOptions.tooltipIndent ?? 0"
                [tooltipHasBeak]="clientTooltipOptions.tooltipHasBeak ?? false"
                [tooltipTheme]="clientTooltipOptions.tooltipTheme ?? ''" ddsFocus
                [tooltipMaxWidth]="clientTooltipOptions.tooltipMaxWidth ?? 0"></span>
        </div>
        <div class="col-4">
          <dds-textarea [placeholder]="textareaOptions.placeholder ?? ''"
                        [minHeight]="textareaOptions.minHeight ?? 0" [maxLength]="textareaOptions.maxLength ?? 0"
                        [maxLengthPosition]="textareaOptions.maxLengthPosition ?? ''" [size]="textareaOptions.size ?? ''"
                        [(ngModel)]="model.consultationSummary"></dds-textarea>
        </div>

      </div>
    </div>
  </div>
</div>
